/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { PageContainer } from "../../../components/container/PageContainer";
import { Breadcrumb } from "../../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import { StandardCard } from "../../../components/Cards";
import { DataTable } from "../../../components/Table/DataTable";
import { Button } from "@mui/material";
import {
  IDataTableProps,
  RenderType,
} from "../../../components/Table/interfaces/IDataTableProps";
import { StandardTableActions } from "../../../components/StandardTableActions/StandardTableActions";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../redux/initialStoreState";
import { LoadState } from "../../../constants/enums";
import { useDispatchWrapper } from "../../../hooks";
import { StatusRenderer } from "../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { RefreshPlugin } from "../../../components/Table/plugins";
import {
  clearSecurityRoleGroupListAsync,
  fetchSecurityRoleGroupListAsync,
} from "../../../redux/security/role-group/role-group.actions";
import { ManageRoleGroupDialog } from "./ManageRoleGroupDialog";
import { ISecurityRoleGroup } from "../../../redux/security/role-group/role-group.types";
import { defaultSecurityRoleGroup } from "../../../redux/security/role-group/role-group.state";
import { formatDateWithTime } from "../../../helpers";
import { toggleSidebar } from "../../../redux/customizer/action";

export const RoleGroupTable: React.FC = () => {
  const BCrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      title: "role-groups",
    },
  ];

  const { list, loading, totalRecords } = useSelector(
    (storeState: IStoreState) => storeState.security.roleGroups
  );
  const dispatch = useDispatchWrapper();

  const [tablePagination, setTablePagination] = React.useState({
    pageNumber: 1,
    rowsInPerPage: 50,
  });
  const [selectedRoleGroup, setSelectedRoleGroup] =
    React.useState<ISecurityRoleGroup | null>(null);

  React.useEffect(() => {
    dispatch(toggleSidebar(false));
  }, []);

  const roleGroupsTableProps: IDataTableProps = {
    isPagination: true,
    totalRecords: totalRecords,
    rowsPerPageOptions: tablePagination.rowsInPerPage,
    isDataLoading: loading !== LoadState.Loaded,
    selectionMode: "none",
    uniqueRowKeyName: "id",
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [
          {
            key: "refresh",
            onRender: () => (
              <RefreshPlugin
                onClick={() => {
                  dispatch(
                    fetchSecurityRoleGroupListAsync(
                      tablePagination.pageNumber,
                      tablePagination.rowsInPerPage
                    )
                  );
                }}
              />
            ),
          },
        ],
      },
      rightItems: {
        plugins: {},
        customPlugins: [],
      },
    },
    columns: [
      {
        key: "role_group",
        headerName: "Role Group",
        fieldName: "role_group",
        enableSorting: true,
        renderType: RenderType.TEXT,
        exportCellWidth: 15,
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        exportCellWidth: 30,
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      {
        key: "create_ts",
        headerName: "Date",
        fieldName: "create_ts",
        enableSorting: true,
        renderType: RenderType.DATE,
        exportCellWidth: 25,
        onExportRender: (values) => {
          return formatDateWithTime(values.value);
        },
      },
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ISecurityRoleGroup) => {
          return (
            <StandardTableActions
              onEditClick={() => setSelectedRoleGroup(row)}
            />
          );
        },
      },
    ],
    items: list,
    onPageChange: (newPageNumber: number) => {
      setTablePagination({ ...tablePagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setTablePagination({
        pageNumber: pageNumber,
        rowsInPerPage: rowsPerPage,
      });
    },
  };

  React.useEffect(() => {
    dispatch(
      fetchSecurityRoleGroupListAsync(
        tablePagination.pageNumber,
        tablePagination.rowsInPerPage
      )
    );
  }, [tablePagination]);

  React.useEffect(() => {
    return () => {
      dispatch(clearSecurityRoleGroupListAsync());
    };
  }, []);

  return (
    <PageContainer title="Role Groups" description="this is inner page">
      <Breadcrumb
        title="View Role Groups"
        items={BCrumb}
        actionButtonText="Create Role Group"
        onActionButtonClick={() =>
          setSelectedRoleGroup(defaultSecurityRoleGroup)
        }
      />
      <StandardCard
        heading=""
        // rightHeading={
        // 	<Button
        // 		variant="contained"
        // 		onClick={() => setSelectedRoleGroup(defaultSecurityRoleGroup)}
        // 	>
        // 		Create Role Group
        // 	</Button>
        // }
      >
        <DataTable {...roleGroupsTableProps} />
      </StandardCard>
      {selectedRoleGroup && (
        <ManageRoleGroupDialog
          open={true}
          roleGroup={selectedRoleGroup}
          onClose={() => setSelectedRoleGroup(null)}
        />
      )}
    </PageContainer>
  );
};
